// 타이머 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역

// =================================================================================================
// 상수
// =================================================================================================
// 시간 대기
const wait = (aFunction, aSec) => {
  setTimeout(
    // 시간 대기
    aFunction,
    1000 * aSec,
  );
};

// 시간 반복
const loop = (aFunction, aSec) => {
  setInterval(
    // 시간 대기
    aFunction,
    1000 * aSec,
  );
};

// =================================================================================================
// 내보내기
// =================================================================================================
export default {
  loop,
  wait,
};
